





























































import { Option } from '~/models/shared/types'
import {
  computed,
  defineComponent,
  PropType,
  ref,
  watch
} from '~/utils/nuxt3-migration'
import { formatNumber } from '~/utils/number'
import { OptionGroup } from '~/components/shared/configurable/form/select/types'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  props: {
    multiSelect: {
      type: Boolean,
      required: true
    },
    internalValue: {
      type: [Array, String, Number],
      default: null
    },
    internalOptions: {
      type: Array as PropType<Option[]>,
      required: true
    },
    optionGroups: {
      type: Array as PropType<OptionGroup[]>,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: undefined
    },
    useNativeSelect: {
      type: Boolean,
      required: true
    },
    textField: {
      type: String,
      default: 'text'
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n()

    const nativeValue = ref()

    watch(
      () => props.internalValue,
      newInternalValue => {
        if (props.multiSelect) {
          nativeValue.value = props.internalValue || []
        } else if (Array.isArray(newInternalValue)) {
          nativeValue.value = newInternalValue.length
            ? newInternalValue[0]
            : null
        } else {
          nativeValue.value = newInternalValue
        }
      },
      { immediate: true, deep: true }
    )

    const internalOptionGroups = computed(() => {
      if (!props.optionGroups.length) {
        return []
      }

      return [
        ...props.optionGroups,
        ...(props.internalOptions.length
          ? [
              {
                label: t('rest_of_options'),
                options: props.internalOptions
              }
            ]
          : [])
      ]
    })

    function onChange(event: Event) {
      const el = event.target as HTMLSelectElement

      // FIXME: This seems sketchy but necessary to get the selected value
      const selectedValue = Array.from(el.options || [])
        .filter(o => o.selected)
        .map(o => ('_value' in o ? (o as any)._value : o.value))

      const value = props.multiSelect ? selectedValue : selectedValue[0]

      emit('change', value)
    }

    return {
      nativeValue,
      internalOptionGroups,
      onChange,
      formatNumber
    }
  }
})
